import React from "react";
import { Grid, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Chart from "react-apexcharts";

const useStyles = makeStyles(() => ({
    root: {
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
    },
}));

const options = {
    series: [50],
    chart: {
        toolbar: {
            show: false,
        },
    },
    colors: ["#c9c9c9"],
    states: {
        hover: {
            filter: {
                type: "none",
            },
        },
    },
    plotOptions: {
        radialBar: {
            hollow: {
                size: "70%",
            },
            dataLabels: {
                showOn: "always",
                name: {
                    offsetY: -15,
                    show: true,
                    color: "#c9c9c9",
                    fontSize: "34px",
                },
                value: {
                    color: "#c9c9c9",
                    fontSize: "36px",
                    show: true,
                    formatter: () => "Coming soon...",
                },
            },
        },
    },
    legend: {
        show: false,
    },
    labels: ["Company Health Score"],
};

export function Section4() {
    const classes = useStyles();

    return (
        <Grid pt={1} pl={1} className={classes.root}>
            <Paper className={classes.root}>
                <Chart options={options} type="radialBar" series={options.series} height={650} />
            </Paper>
        </Grid>
    );
}
